import React from 'react';
import cn from 'classnames';
import { ProductAttributeSelectorProps } from '../ProductAttributeSelector';
import styles from './ProductAttributeSimpleSelector.module.scss';

const ProductAttributeSimpleSelector = ({ selector, options, onClick, theme }: ProductAttributeSelectorProps) => (
  <div className={cn(styles.simpleSelector, styles[`theme-${theme}`])}>
    <div className={styles.selectorName}>{selector.name}:</div>
    <div className={styles.options}>
      {options.map((option) => (
        <div
          data-type="product-page-selector-option"
          data-attribute-type-name={selector.name}
          data-attribute-value={option.value}
          data-attribute-name={option.name}
          key={`ss${option.value}`}
          className={cn(styles.option, {
            [styles.selected]: option.selected,
            [styles.disabled]: option.disabled,
          })}
          onClick={() => onClick(selector.typeName, option.value, option.productId)}
        >
          {option.name}
        </div>
      ))}
    </div>
  </div>
);

export default ProductAttributeSimpleSelector;
